<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function() {
    let startTime = Date.now();
    
    let interval = setInterval(function() {
        if ($('#eosh-mpc-field-block').length > 0) {
            $('#eo-sh-width').val('1');
            clearInterval(interval);
            return;
        }
        
        if (Date.now() - startTime >= 10000) {
            clearInterval(interval);
        }
    }, 1000);
});